import React, { useEffect, useState } from "react";
import "./signature-profiles.css";
import {
  ListBoxTemplatePure,
  DialogTemplatePure,
  HeaderHLPure,
  ButtonAddHLPure,
  GridSelectionHLPure,
  ButtonHLPure,
  DialogYesNoHLPure,
  DialogSystemGLPure,
} from "../../pures";
import { useMediaQuery } from "@material-ui/core";
import { PromotionalFooterPure } from "../../pures";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import {
  SignatureProfileService,
  UserSignatureProfileService,
  UserService,
} from "../../../services";
import { Container, Grid } from "@material-ui/core";

const HeaderColumns = (props) => {
  return <span className={(props.title === props.t("signatureProfilesView.grid.profile")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>;
};

export default function SignatureProfilesView(props) {
  const {
    profiles,
    token,
    getProfiles,
    // id,
    // userProfileInEdit
  } = props;
  const { t } = useTranslation();

  const url = process.env.REACT_APP_MIFIRMA_API;
  const signatureProfileService = new SignatureProfileService(url);
  const userSignatureProfileService = new UserSignatureProfileService(url);
  const userService = new UserService(url);

  const history = useHistory();
  const showRegistered = useMediaQuery("(min-width:720px)");
  const showActions = useMediaQuery("(min-width:560px)");

  const [dataItem, setDataItem] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [textError, setTextError] = useState("");

  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [showDialogAssignment, setShowDialogAssignment] = useState(false);
  const toggleDialogAssignment = () =>
    setShowDialogAssignment(!showDialogAssignment);
  const toggleDialogDelete = () => {
    setShowDialogDelete(!showDialogDelete);
  };

  const [notAssignedUsersOriginal, setNotAssignedUsersOriginal] = useState([]);
  const [assignedUsersOriginal, setAssignedUsersOriginal] = useState([]);
  const [notAssignedUsers, setNotAssignedUsers] = useState([]);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [notAssignedUsersNew, setNotAssignedUsersNew] = useState([]);
  const [assignedUsersNew, setAssignedUsersNew] = useState([]);
  const [userProfileInEdit, setUserProfileInEdit] = useState(undefined);

  const deleteSigatureProfiles = async () => {
    setShowDialogDelete(false);
    setIsLoading(true);
    try {
      let result = await signatureProfileService.deleteSigatureProfiles(
        token,
        dataItem.id
      );
      let profileDeleteStatus = Number(result.statusCode);
      if (profileDeleteStatus !== 200) {
        switch (profileDeleteStatus) {
          case -2:
            setTextError(
              "No se pudo encontrar el perfil de usuario seleccionado."
            );
            throw new Error();
          case -3:
            setTextError(
              "El perfil de usuario está asignado a uno o varios usuarios."
            );
            throw new Error();
          default:
            setTextError(
              "Ocurrió un error al realizar la petición, intente nuevamente."
            );
            throw new Error();
        }
      } else {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          getProfiles();
        }, 4000);
      }
    } catch (e) {
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 4000);
    } finally {
      setIsLoading(false);
      setNameComponentUser("");
    }
  };

  const MyCustomItem = (props) => {
    let { dataItem, selected, ...others } = props;
    return (
      <li {...others}>
        <span> {props.dataItem.name} </span>
      </li>
    );
  };

  //Copy the dataItem
  const cloneUser = (user) => {
    return Object.assign({}, user);
  };

  //Get users profiles
  const getUserProfile = async (dataItem) => {
    setIsLoading(true);
    setUserProfileInEdit(cloneUser(dataItem));
    try {
      //Get information from listOne
      let userNotAssigned = await userService.getUsersCollaboratorInvite(token);
      // let userNotAssignedStatus = Number(userNotAssigned.statusCode)

      //Get information from listTwo
      let userAssigned = await userSignatureProfileService.getUsersProfiles(
        token,
        dataItem.id
      );
      let userAssignedStatus = Number(userAssigned.statusCode);
      let userNotAssignedListTwo = [];

      if (userAssignedStatus === 200) {
        //Get complete name to every user from listOne
        userNotAssigned.usersCollaborator =
          userNotAssigned.usersCollaborator.map((user) => {
            let name =
              user.firstName +
              " " +
              user.firstLastName +
              " " +
              user.secondLastName;
            user.name = name;
            user.selected = false;
            return user;
          });

        //Delete users that not have complete name in array
        userNotAssignedListTwo = userNotAssigned.usersCollaborator.filter(
          (item) => item.name !== "  "
        );

        //Get complete name to every user from listTwo
        userAssigned.data.map((userInfo) => {
          let name =
            userInfo.userInformation.firstName +
            " " +
            userInfo.userInformation.firstLastName +
            " " +
            userInfo.userInformation.secondLastName;
          userInfo.name = name;
          userInfo.selected = false;
          return userInfo;
        });
        setNotAssignedUsersOriginal(userNotAssigned.usersCollaborator);
        setAssignedUsersOriginal(userAssigned.data);

        // setIsLoading(false)
        let verifiedAvaibleList = []; // Tabla izquierda
        let verifiedAssignedList = []; // Tabla derecha

        // 7.- Llenar lista para tabla derecha (verifiedAssignedList)
        for (let i = 0; i < userAssigned.data.length; i++) {
          verifiedAssignedList.push({
            userId: userAssigned.data[i].userId,
            signatureProfileId: userAssigned.data[i].signatureProfileId,
            selected: userAssigned.data[i].selected,
            name: userAssigned.data[i].name,
          });
        }

        // 8.- Se filtran los valores no repetidos obtenidos de userNotAssigned
        let userNotAssignedFiltered = userNotAssignedListTwo.filter((obj1) => {
          return !userAssigned.data.some((obj2) => {
            return obj1.id === obj2.userId;
          });
        });
        // 9.- Llenar lista para tabla izquierda (verifiedAvaibleList)
        verifiedAvaibleList = userNotAssignedFiltered.map((item) => {
          let result = {
            userId: item.id,
            signatureProfileId: dataItem.id,
            selected: item.selected,
            name: item.name,
          };
          return result;
        });

        // 10.- Se almacenan los valores en el state
        setNotAssignedUsers(verifiedAvaibleList);
        setAssignedUsers(verifiedAssignedList);
        setIsLoading(false);
      } else {
        setNotAssignedUsers(userNotAssignedListTwo);
        setAssignedUsers(userAssigned.data);
        setIsLoading(false);
      }

      setIsLoading(false);
      setShowDialogAssignment(!showDialogAssignment);
    } catch (error) {
      console.log(error);
      setTextError("Ocurrió un error obteniendo el perfil de usuario.");
      setIsLoading(false);
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 4000);
      return false;
    }
  };

  //Actualizar listas
  const listResult = (listOne, listTwo) => {
    setNotAssignedUsersNew(listOne);
    setAssignedUsersNew(listTwo);
  };

  const onSubmitUser = async (e) => {
    e.preventDefault();
    let backendStatusCode = 0;
    setIsLoading(true);

    // Filtrar perfiles por agregar al usuario
    let assignedUsersProfilesFiltered = assignedUsersNew.filter((obj1) => {
      return !assignedUsersOriginal.some((obj2) => {
        return obj1.userId === obj2.userId;
      });
    });

    // Filtrar perfiles por eliminar del usuario
    let deletedUsersProfilesFiltered = notAssignedUsersNew.filter((obj1) => {
      return assignedUsersOriginal.some((obj2) => {
        return obj1.userId === obj2.userId;
      });
    });

    try {
      if (
        assignedUsersProfilesFiltered.length <= 0 &&
        deletedUsersProfilesFiltered.length <= 0
      )
        return false;

      // Agregar perfil de firma a usurio
      if (assignedUsersProfilesFiltered.length > 0) {
        let usersProfilesToAssign = [];
        for (let i = 0; i < assignedUsersProfilesFiltered.length; i++) {
          usersProfilesToAssign.push({
            userId: assignedUsersProfilesFiltered[i].userId,
            signatureProfileId:
              assignedUsersProfilesFiltered[i].signatureProfileId,
          });
        }
        let usersProfilesAssigned =
          await userSignatureProfileService.createProfilesUser(
            usersProfilesToAssign,
            token
          );
        if (usersProfilesAssigned.statusCode != 200) {
          backendStatusCode = usersProfilesAssigned.statusCode;
          throw new Error();
        }
      }
      // Eliminar perfil de firma de usuario
      if (deletedUsersProfilesFiltered.length > 0) {
        let usersProfilesToDelete = [];
        for (let i = 0; i < deletedUsersProfilesFiltered.length; i++) {
          usersProfilesToDelete.push({
            userId: deletedUsersProfilesFiltered[i].userId,
            signatureProfileId:
              deletedUsersProfilesFiltered[i].signatureProfileId,
          });
        }

        const arrayToDelete = `${JSON.stringify(usersProfilesToDelete)}`;
        let usersProfilesDeleted =
          await userSignatureProfileService.deleteUserProfiles(
            arrayToDelete,
            token
          );
        if (usersProfilesDeleted.statusCode != 200) {
          backendStatusCode = usersProfilesDeleted.statusCode;
          throw new Error();
        }
      }
      setShowDialogAssignment(!showDialogAssignment);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 4000);
      return true;
    } catch (error) {
      setTextError("Ocurrió un error agregando al usuario.");
      setError(true);
      setTimeout(() => {
        setError(false);
      }, 4000);
      return false;
    } finally {
      setNameComponentUser("");
      setIsLoading(false);
    }
  };

  const ColumnOneCell = (props) => {
    return <td><p className='grid-cell-titles-margin-left'>{props.dataItem.name}</p></td>;
  };

  const ColumnTwoCell = (props) => {
    const user = props.dataItem.user;
    return (
      <td>
        {user["firstName"]} {user["firstLastName"]}
      </td>
    );
  };

  const [nameComponentUser, setNameComponentUser] = useState("");

  useEffect(() => {
    if (!dataItem || !dataItem.id || nameComponentUser === "") return;

    switch (nameComponentUser) {
      case t("signatureProfilesView.grid.seeDetails"):
        history.push(`/signature-profile-details/${dataItem.id}`);
        break;

      case "Asignar usuarios":
        getUserProfile(dataItem);
        break;
    }
  }, [dataItem, nameComponentUser]);

  let AllHeadersColumns = (props) => <HeaderColumns {...props} t={t} />

  return (
    <>
      <div className={"signatureProfileView"}>
        <Grid container className="main-container">
          <Grid style={{ padding: "10px 0px" }} item xs={12}>
            <HeaderHLPure
              title={t("signatureProfilesView.titleUserProfile")}
            />
          </Grid>
          <Grid item xs={12}>
            <ButtonAddHLPure
              nameBtn={t("signatureProfilesView.btnAddUserProfile")}
              onClickBtn={() =>
                history.push("/signature-profile-details")
              }
              iconAdd
            />
          </Grid>
          <Grid item xs={12}>
            <GridSelectionHLPure
              skip={0}
              take={6}
              dataGrid={profiles}
              styleGeneral
              styleGeneralClass={"signatureProfilesView-grid"}
              titleRow1={t("signatureProfilesView.grid.profile")}
              headerColumnOne={AllHeadersColumns}
              cellColumnOne={ColumnOneCell}
              columnTwo={showRegistered}
              titleRow2={t("signatureProfilesView.grid.registeredBy")}
              headerColumnTwo={AllHeadersColumns}
              cellColumnTwo={ColumnTwoCell}
              columnFive
              titleRow5={showActions ? t("signatureProfilesView.grid.actions") : ""}
              headerColumnFiveClass={"signatureProfilesView-grid-col5"}
              columnFiveStyleClass={"signatureProfilesView-grid-col5"}
              onSelectedItem={setDataItem}
              setShowDetails={() => { }}
              setNameComponentUser={setNameComponentUser}
              iconOneActive
              labelOneActions={t("signatureProfilesView.grid.seeDetails")}
              labelFourthActions={t("signatureProfilesView.grid.seeDetails")} // Arrow
              // iconTwoActive
              // labelTwoActions={"Asignar usuarios"}
              // iconTrashActive
              activeDialogTrash={true}
              labelTrashActions={"Eliminar"}
              btnOpenDialogTrash={(dataItem, _) => {
                setDataItem(dataItem);
                toggleDialogDelete();
              }}
            />
          </Grid>
          <Grid item container xs={12} justify="flex-end">
            <ButtonHLPure
              nameBtn={t("signatureProfilesDetailsView.back")}
              onClickBtn={() => history.push("/configuration")}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <PromotionalFooterPure />
        </Grid>
      </div>
      {showDialogDelete && (
        <DialogYesNoHLPure
          titleDialog={t("ModalDelete.title")}
          loadingComponent={isLoading}
          textBtnCancel={t("ModalDelete.cancel")}
          cancel={() => {
            setNameComponentUser("");
            toggleDialogDelete();
          }}
          saveBtn={t("ModalDelete.delete")}
          handleSubmit={deleteSigatureProfiles}
        >
          <Grid container>
            <Grid item xs={12}>
              <p>
                ¿Estas seguro de eliminar el perfil{" "}
                <span
                  style={{ fontWeight: "bold", marginLeft: "4px" }}
                >{`${dataItem.name}`}</span>
                ?
              </p>
            </Grid>
          </Grid>
        </DialogYesNoHLPure>
      )}
      {showDialogAssignment && (
        <DialogTemplatePure
          canelBtn={t("ModalAssignment.btnCancel")}
          saveBtn={t("ModalAssignment.btnSubmit")}
          title={t("ModalAssignment.assignTitle")}
          description={t("ModalAssignment.description")}
          cancel={() => {
            setNameComponentUser("");
            toggleDialogAssignment();
          }}
          textError={textError}
          handleSubmitProfile={(e) => onSubmitUser(e)}
          dataItem={userProfileInEdit}
        >
          <ListBoxTemplatePure
            //{...props}
            titleListOne={t("signatureProfilesView.avaibleProfiles")}
            titleListTwo={t("signatureProfilesView.assignedProfiles")}
            listDataOne={notAssignedUsers}
            listDataTwo={assignedUsers}
            loadingComponent={isLoading}
            textField="name"
            item={MyCustomItem}
            listResult={listResult}
          />
        </DialogTemplatePure>
      )}
      <DialogSystemGLPure
        showLoadingRequesting={isLoading}
        toggleLoadingRequesting={() => setIsLoading((prev) => !prev)}
        showCompletedRequesting={success}
        toggleCompletedRequesting={() => setSuccess((prev) => !prev)}
        showErrorRequesting={error}
        toggleErrorRequesting={() => setError((prev) => !prev)}
        messageError={textError}
      />
    </>
  );
}
